import axios from "axios";
import * as AxiosLogger from 'axios-logger';

if (process.env.NODE_ENV === 'development') {
    axios.defaults.baseURL = "http://localhost:3000/api/v1";
    axios.interceptors.request.use(AxiosLogger.requestLogger);
} else {
    axios.defaults.baseURL = "/api/v1";
}
axios.defaults.headers.post['Content-Type'] = 'application/json';